import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},0.5)`} fill="none">
      <path
        d="M29.55 129.16C45.1134 129.16 57.73 100.632 57.73 65.44C57.73 30.2484 45.1134 1.71997 29.55 1.71997C13.9866 1.71997 1.37 30.2484 1.37 65.44C1.37 100.632 13.9866 129.16 29.55 129.16Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
